import { showPopUp } from './utils';

export function initPopUp(instance) {
  showPopUp(instance);
}
